<template>
  <div
    class="s-bg-white s-flex s-items-center s-justify-between s-p-3 s-gap-4 
        s-border-b-gray-200 s-border-b s-w-full" 
    style="padding-right: 32px; padding-left: 32px; border-bottom-style: solid"
  >
    <div class="s-flex s-items-center s-gap-4">
      <img
        src="@/app/assets/images/brand/cv-logo-white.svg"
        width="40px"
        alt="CB Payments"
      />
      <div class="s-flex s-flex-col s-justify-evenly s-items-start s-gap-2">
        <h1 class="s-text-xl s-font-semibold">
          Set up Chargebee Pay
        </h1>
        <div class="s-text-sm s-leading-none">
          {{ getMerchantName }}
        </div>
      </div>
    </div>
    
    <div class="s-flex s-gap-2" v-if="showHeaderActions">
      <s-button
        :variant="'outline'"
        size="large"
        @click="dismiss"
        :disabled="saveAndCloseLoading"
      >
        {{ $t('global.action.dismiss') }}
      </s-button>

      <s-button
        :variant="'neutral'"
        size="large"
        @click="saveAsDraft"
        :disabled="disableSaveAsDraft"
        v-if="!addBankAccountView"
      >
        {{ $t('onboarding.saveAsDraft') }}
      </s-button>
    </div>
  </div>
</template>

<script>
import { OnboardingStep} from '@/app/utils/common/constants';
import { callbackApplication } from '@/app/utils/common/functions/functions';
import FullStoryHelper from '@/app/utils/fullstory';
import { TERMS_AND_CONDITIONS_POPUP } from '@/app/utils/fullstory/constants';
import { saveMerchantAsDraft } from '@/service/merchantService';
import { mapActions, mapGetters } from 'vuex';
import {getAndStoreSession} from "@/service/sessionService";

export default {
  name: 'OnboardingHeader',
  props: {
    dismiss: {
      type: Function,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
    addBankAccountView: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    showDismissConfirmation: false,
    showSubmitPopup: false,
    saveAndCloseLoading: false,
  }),
  computed: {
    ...mapGetters('app', [
      'getCallbackUrl',
      'getMerchantName',
      'getMerchantId',
      'getDraftMerchantId',
      'getAutoSavedDraftMerchantId',
      'getSessionPayfac'
    ]),
    ...mapGetters('businessProfile', { isBusinessProfileValid: 'isValid' }),
    ...mapGetters('businessAddress', { isBusinessAddressValid: 'isValid' }),
    ...mapGetters('businessStructure', { isBusinessStructureValid: 'isValid' }),
    ...mapGetters('stakeholdersDetails', {
      isStakeholdersDetailsValid: 'isValid',
    }),
    ...mapGetters('additionalUnderwritingData', {
      isAdditionalUnderwritingDataValid: 'isValid',
    }),
    ...mapGetters('bankAccountForPayouts', {
      isBankAccountForPayoutsValid: 'isValid',
    }),
    ...mapGetters('merchantPayfacDetails', ['getOnboardingStep']),
    enableSubmitButton() {
      return (
        this.isBusinessProfileValid &&
        this.isBusinessAddressValid &&
        this.isBusinessStructureValid &&
        this.isStakeholdersDetailsValid &&
        this.isAdditionalUnderwritingDataValid &&
        this.isBankAccountForPayoutsValid
      );
    },
    showHeaderActions() {
      if (this.currentStep === -1) {
        let onboardingStep = this.getOnboardingStep(this.getSessionPayfac);
        return onboardingStep !== OnboardingStep.NOT_INITIATED;
      }
      return true;
    },
    disableSaveAsDraft() {
      let onboardingStep = this.getOnboardingStep(this.getSessionPayfac);
      return this.saveAndCloseLoading || (onboardingStep === OnboardingStep.NOT_INITIATED);
    }
  },
  methods: {
    ...mapActions('app', ['updateAppState']),
    ...mapActions('onboarding', ['setAutoSaveStatus']),
    onboardMerchant() {
      this.showSubmitPopup = true;
      FullStoryHelper.event(TERMS_AND_CONDITIONS_POPUP);
    },
    saveAsDraft() {
      this.saveAndCloseLoading = true;
      this.setAutoSaveStatus(false);
      saveMerchantAsDraft().then(async (response) => {
          this.$success(this.$t('global.toast.savedAsDraft'));
          await this.updateAppState({
            key: 'draftMerchantId',
            value: response.draft_id,
          });
          await getAndStoreSession();
          this.openCallbackUrl();
        })
        .catch((err) => {
          this.saveAndCloseLoading = false;
          this.$danger(
            this.$t('errors.submitOnboardingFailed') +
              ' - ' +
              err.source?.detail
          );
        }).finally(() => {
          this.saveAndCloseLoading = false;
        });
    },
    openCallbackUrl() {
      callbackApplication(
        this.getCallbackUrl,
        this.getMerchantId,
        this.getAutoSavedDraftMerchantId,
        this.getOnboardingStep(this.getSessionPayfac)
      );
    },
  },
};
</script>
<style lang="scss">
.logo {
  position: relative;
  font-size: 0;
  @include c-box(46px);
  background-image: url('~@/app/assets/images/brand/cv-logomask-primary.svg');
  background-repeat: no-repeat;
  background-size: contain;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:before {
    content: '';
    @include c-box(26px);
    background-image: url('~@/app/assets/images/brand/cv-logo-white.svg');
    background-size: contain;
    background-repeat: no-repeat;
    display: inline-block;
  }
}

</style>
